import React from "react";
import { ActionIcon, Button } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import Modal from "react-modal";
import { RiCloseLargeFill } from "react-icons/ri";

import NetsEasySubscription from "./NetsEasySubscription";

const customStyles = {
  content: {
    height: "100%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    marginTop: "1rem",
    transform: "translate(-50%, -50%)",
    width: "30rem",
  },
};

const useStyles = createStyles((theme) => ({
  appLayout: {
    height: `${theme.height - 1}px`,
    overflowY: "scroll",
    display: "flex",
    flexDirection: "column",
  },
  onepageHeader: {
    textAlign: "center",
  },
  close: {
    position: "absolute",
    top: "0.35rem",
    right: "0.35rem",
    color: "black",
    background: "transparent",
    "&:hover": {
      color: "black",
      background: "rgb(248, 249, 250)",
    },
  },
}));

const SubscriptionModal = ({
  goToPayment,
  language,
  data,
  subscriptionId,
  updateSubscription,
}) => {
  const { classes } = useStyles();

  return (
    <Modal
      isOpen={goToPayment}
      onRequestClose={() => window.location.reload()}
      contentLabel={language.Payment}
      style={customStyles}
      aria={{
        labelledby: "subscription-title",
      }}
      shouldCloseOnOverlayClick={false}
    >
      <h2 id="subscription-title">{language.Payment}</h2>
      <ActionIcon
        aria-label={language.Close}
        className={classes.close}
        onClick={() => window.location.reload()}
      >
        <RiCloseLargeFill />
      </ActionIcon>
      <div className={classes.onepageHeader}>
        <span className="cart__onepage-abortlink">
          <Button
            variant="primary"
            className={`${classes.cancelButton} primaryButton onepage_payment__cancel`}
            onClick={() => window.location.reload()}
          >
            {language.Cancel_Payment}
          </Button>
        </span>
      </div>
      <NetsEasySubscription
        paymentMethods={data.paymentMethods}
        subscriptionId={subscriptionId}
        updateSubscription={updateSubscription}
      />
    </Modal>
  );
};

export default SubscriptionModal;
